import moment from 'moment'

export default function (value, na='n/a', time=true) {
  return value && value !== '' ? moment(value).format('MMM Do, YYYY' + (time ? ', h:mma' : '')) : na
}
